import { loadImage } from "../../../Publish/BulkUpload/Script/bulkUpload"

// export const drawSign = (data) => {
//   return new Promise(async (resolve, reject) => {
//     try {
//       // const originalWidth = 900
//       // const originalHeight = 200
//       const canvasWidth = 450
//       const canvasHeight = 100

//       const canvas = document.createElement("canvas") // Use existing canvas!
//       canvas.width = canvasWidth
//       canvas.height = canvasHeight

//       const ctx = canvas.getContext("2d")

//       const gradient = ctx.createLinearGradient(0, 0, canvas.width, canvas.height)
//       gradient.addColorStop(0.0, "#a6e0ce")
//       gradient.addColorStop(1.0, "#f3e7be")

//       ctx.fillStyle = gradient
//       ctx.fillRect(0, 0, canvas.width, canvas.height)

//       const imgName = data.showQR ? "qr" : "flower"
//       const qrImage = await loadImage(`assets/img/${imgName}.png`)
//       ctx.drawImage(qrImage, 12, 8, 76, 76)

//       ctx.fillStyle = "black"
//       ctx.font = "bold 16px Arial"
//       ctx.fillText(`To be ${data.role == "APPROVER" ? "Approved" : "Signed"} by,`, 115, 25)

//       ctx.font = "bold 22px Arial"
//       ctx.fillText(data.name, 115, 58)

//       ctx.strokeStyle = "#6d6d6d"
//       ctx.lineWidth = 6
//       ctx.beginPath()
//       ctx.moveTo(17, 90)
//       ctx.lineTo(83, 90)
//       ctx.stroke()

//       ctx.lineWidth = 8
//       ctx.beginPath()
//       ctx.moveTo(115, 90)
//       ctx.lineTo(300, 90)
//       ctx.stroke()

//       ctx.lineWidth = 8
//       ctx.beginPath()
//       ctx.moveTo(115, 68)
//       ctx.lineTo(350, 68)
//       ctx.stroke()

//       const stripGradient = ctx.createLinearGradient(0, 0, 0, canvas.height)
//       stripGradient.addColorStop(0, "#FFCC70")
//       stripGradient.addColorStop(0.5, "#C850C0")
//       stripGradient.addColorStop(1, "#4158D0")

//       ctx.strokeStyle = stripGradient
//       ctx.lineWidth = 6
//       ctx.beginPath()
//       ctx.moveTo(103, 0)
//       ctx.lineTo(103, 100)
//       ctx.stroke()

//       canvas.toBlob((blob) => {
//         if (blob) {
//           const blobUrl = URL.createObjectURL(blob)
//           resolve(blobUrl)
//         } else {
//           reject("Failed to generate blob.")
//         }
//       }, "image/png")
//     } catch (err) {
//       reject(err)
//     }
//   })
// }

export const drawSign = (data) => {
  return new Promise(async (resolve, reject) => {
    try {
      // const originalWidth = 800
      // const originalHeight = 200

      const newWidth = 400
      const newHeight = 100

      const canvas = document.createElement("canvas")
      canvas.width = newWidth
      canvas.height = newHeight

      const ctx = canvas.getContext("2d")

      const gradient = ctx.createLinearGradient(0, 0, canvas.width, canvas.height)
      gradient.addColorStop(0.0, "#a6e0ce")
      gradient.addColorStop(1.0, "#f3e7be")

      ctx.fillStyle = gradient
      ctx.fillRect(0, 0, canvas.width, canvas.height)

      const imgName = data.showQR ? "qr" : "flower"
      const qrImage = await loadImage(`assets/img/${imgName}.png`)
      ctx.drawImage(qrImage, 9, 8, 74, 74)

      ctx.fillStyle = "black"
      ctx.font = "bold 11px Arial"
      ctx.fillText(`To be ${data.role == "APPROVER" ? "Approved" : "Signed"} by,`, 109, 22)

      let name = data.name

      const nameX = 109
      const nameY = 56
      const maxNameWidth = canvas.width - nameX * 1 - 10
      // console.log({ maxNameWidth })

      name = name.toUpperCase()
      // console.log(name)
      await drawWrappedName(ctx, name, nameX, nameY, maxNameWidth, 16, 8)
      // console.log({ maxNameWidth })

      ctx.strokeStyle = "#6d6d6d"
      ctx.lineWidth = 6
      ctx.beginPath()
      ctx.moveTo(13, 90)
      ctx.lineTo(79, 90)
      ctx.stroke()

      ctx.lineWidth = 8
      ctx.beginPath()
      ctx.moveTo(109, 90)
      ctx.lineTo(290, 90)
      ctx.stroke()

      ctx.lineWidth = 8
      ctx.beginPath()
      ctx.moveTo(109, 72)
      ctx.lineTo(340, 72)
      ctx.stroke()

      const stripGradient = ctx.createLinearGradient(0, 0, 0, canvas.height)
      stripGradient.addColorStop(0, "#FFCC70")
      stripGradient.addColorStop(0.5, "#C850C0")
      stripGradient.addColorStop(1, "#4158D0")

      ctx.strokeStyle = stripGradient
      ctx.lineWidth = 6
      ctx.beginPath()
      ctx.moveTo(94, 0)
      ctx.lineTo(94, 100)
      ctx.stroke()

      canvas.toBlob((blob) => {
        if (blob) {
          const blobUrl = URL.createObjectURL(blob)
          resolve(blobUrl)
        } else {
          reject("Failed to generate blob.")
        }
      }, "image/png")
    } catch (err) {
      reject(err)
    }
  })
}

const drawWrappedName = (ctx, name, x, y, maxWidth, maxFontSize, minFontSize) => {
  let fontSize = maxFontSize
  let lines = [name]
  ctx.font = `bold ${fontSize}px Arial`

  if (ctx.measureText(name).width > maxWidth) {
    lines = splitToTwoLines(ctx, name)
    while (fontSize > minFontSize) {
      // console.log({ fontSize })
      let fits = lines.every((line) => ctx.measureText(line).width <= maxWidth)
      // console.log(fits)
      if (fits) {
        break
      } else {
        fontSize--
        ctx.font = `bold ${fontSize}px Arial`
      }
    }
  }
  ctx.fillStyle = "black"
  const lineHeight = fontSize
  const totalHeight = lines.length * lineHeight
  const startY = y - totalHeight / 2 + lineHeight / 2

  lines.forEach((line, i) => {
    ctx.fillText(line, x, startY + i * lineHeight)
  })

  return { fontSize, lines }
}

const splitToTwoLines = (ctx, text) => {
  const words = text.split(" ")
  let bestSplitIndex = 1
  let minMaxWidth = Infinity

  for (let i = 1; i < words.length; i++) {
    const line1 = words.slice(0, i).join(" ")
    const line2 = words.slice(i).join(" ")
    const width1 = ctx.measureText(line1).width
    const width2 = ctx.measureText(line2).width
    const currentMaxWidth = Math.max(width1, width2)

    if (currentMaxWidth < minMaxWidth) {
      minMaxWidth = currentMaxWidth
      bestSplitIndex = i
    }
  }

  const firstLine = words.slice(0, bestSplitIndex).join(" ")
  const secondLine = words.slice(bestSplitIndex).join(" ")
  return [firstLine, secondLine]
}
